import * as React from "react";
import type { SVGProps } from "react";
const SvgTailwindAirlinesCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#00acc8"
      d="M4.5 38.439c3.384-4.25 7.552-10.73 13.144-14.271 8.264-5.241 14 2.797 17.74 9.667C38.34 39.29 41.51 45.31 45.5 48c-10.045-3.01-14.035-19.476-28.105-16.679-5.2 1.062-9.226 4.816-12.895 7.118"
    />
    <path
      fill="#575656"
      d="M42.401 47.61c-5.308-2.939-14.39-6.48-18.915-11.615-1.21-1.38-1.959-2.726-2.422-4.037 10.33.921 14.07 11.722 21.337 15.653M24.27 21.76c2.03-2.337 4.702-4.497 7.267-6.41 5.45-4.143 9.902-8.144 11.719-13.35.712 8.995-9.368 15.546-12.147 23.761-1.995-2.16-4.239-3.683-6.84-4.001"
    />
  </svg>
);
export default SvgTailwindAirlinesCopy;
